module.exports = __webpack_public_path__ + "static/media/back_arrow.068cdd7b.svg";